import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/joy';

const ProtectedRoute = ({ children, requiredPermission = null, adminOnly = false }) => {
  const { user, loading, isAdmin, hasPermission } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
        }}
      >
        <CircularProgress size="lg" />
        <Typography level="body-md">Loading...</Typography>
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && !isAdmin()) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '50vh',
          gap: 2,
          textAlign: 'center',
        }}
      >
        <Typography level="h3" color="danger">
          Access Denied
        </Typography>
        <Typography level="body-md" color="neutral">
          You don't have administrator privileges to access this page.
        </Typography>
      </Box>
    );
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '50vh',
          gap: 2,
          textAlign: 'center',
        }}
      >
        <Typography level="h3" color="danger">
          Access Denied
        </Typography>
        <Typography level="body-md" color="neutral">
          You don't have the required permissions to access this page.
        </Typography>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;